import {Component, OnInit, Optional} from '@angular/core';
import {ITableHeader} from '../../../interfaces/table-header';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {AccountService} from '../../services/account.service';
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";

@Component({
  selector: 'table-account',
  templateUrl: './table-account.component.html',
  providers: [LoaderService]
})
export class TableAccountComponent extends TableEntityExtension implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.id(),
    this.tableHeaderService.email({sort: false}),
    this.tableHeaderService.provider({sort: false}),
    this.tableHeaderService.info({sort: false, filter: false}),
    this.tableHeaderService.createdAt(),
    // this.tableHeaderService.actions(),
  ];

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: AccountService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private tableHeaderService: TableHeaderService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.routesInit('accounts');
  }
  toggleJson(event: any, item) {
    item.show = !item.show;
  }
}
